import { createContext } from 'react';

// Data pre-fetched by the Express server during SSR (ssr-data.js) and
// injected into the page as window.__INITIAL_DATA__. Lets listing/detail
// pages render their content server-side instead of a loading spinner.
const initialDataContext = createContext(null);

export default initialDataContext;
